var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.993 8.536h-3.463v-2.926c0-1.328-1.076-2.405-2.405-2.405h-16.514c-1.328 0-2.405 1.077-2.405 2.405v22.383c0 0.443 0.359 0.802 0.802 0.802h23.986c0.443 0 0.802-0.359 0.802-0.802v-18.655c0-0.443-0.359-0.802-0.802-0.802zM5.61 4.271h16.514c0.738 0 1.339 0.601 1.339 1.339v2.926h-19.192v-2.926c0-0.738 0.601-1.339 1.339-1.339zM27.729 27.729h-23.457v-18.126h23.457v18.126z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.265 18.666c0 1.472 1.194 2.665 2.666 2.665s2.665-1.193 2.665-2.665c0-1.472-1.193-2.666-2.665-2.666s-2.666 1.193-2.666 2.666zM24.53 18.666c0 0.881-0.717 1.598-1.599 1.598s-1.6-0.717-1.6-1.598c0-0.882 0.718-1.599 1.6-1.599s1.599 0.717 1.599 1.599z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.f805de0c7594dc03ae9f4076b00ce6ec.svg";
export { ForwardRef as ReactComponent };